export default __webpack_public_path__ + "audios/d8cb7867636919a3445f3f30757fadc5.mp3";